import React, { useState } from 'react';
import Stack from "@mui/material/Stack";
import Alert from '@mui/material/Alert';
import {Button} from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {history, uxscreen} from "../_services/essentials/helpers";
import {Navigate} from "react-router-dom";
import {discoveryActions, masterProfilesActions as myActions} from "../_services/essentials/store";
import {useDispatch} from "react-redux";

export { PageNavigation };

function PageNavigation() {
    const [url, setUrl] = useState(history.location?.state?.url);
    //alert(url);
    const dispatch = useDispatch();
    if(url === '/discovery/identified_profiles' || url === '/master_profiles' || url === '/master_profiles?user_projects=true'){
        dispatch(discoveryActions.setFilter({})).unwrap();
    }

    return <Navigate to={url} state={{}} />
}